<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Cancel Sale</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" xs="12" sm="3" md="3">
            <v-autocomplete
              name="CancelCustomer"
              dense
              outlined
              v-model="record.CustomerID"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <v-autocomplete
              name="CancelProduct"
              dense
              outlined
              v-model="record.ProductID"
              :items="products"
              label="Product"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="3" md="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" sm="3" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <v-btn color="accent" :loading="reportLoader" @click="getReport">Query Data</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field dense outlined label="Search" v-model="search"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-data-table disable-sort :headers="headers" :items="cancelData" :search="search" :mobile-breakpoint="0">
              <template v-slot:item.Price="{ item }">{{ item.Price.toLocaleString() }}</template>

              <template v-slot:item.LineTotal="{ item }">{{ item.LineTotal.toLocaleString() }}</template>

              <template v-slot:item.ReturnedQty="{ item }">
                <v-text-field
                v-show="item.Quantity>0"
                  style="width: 70px"
                  name="ReturnedQuantity"
                  single-line
                  outlined
                  dense
                  v-model="item.ReturnedQty"
                ></v-text-field>
              </template>

              <template v-slot:item.DocDate="{ item }">
                <span style="display: inline-block; margin-left: 2px; width: 100px;">{{item.DocDate}}</span>
              </template>
            </v-data-table>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-col>

          <v-col cols="12">
            <v-btn style="margin-top: -80px" class="primary" :loading="loader" @click="save">Save</v-btn>
          </v-col>
        </v-row>

      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
import "jspdf-autotable";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data() {
    return {
      record: {},
      menu1: false,
      menu2: false,
      loader: false,
      reportLoader: false,
      search: null,
      customers: [],
      cancelData: [],
      products: [],
      reportData: {},
      headers: [
        { text: "Product", value: "product.Name" },
        // { text: "Ref No./ Imei", value: "ref1" },
        // { text: "Customer Id. No", value: "ref2" },
        { text: "Quantity", value: "Quantity" },
        { text: "Qty", value: "ReturnedQty" },
        // { text: "Price", value: "Price" },
        // { text: "Total", value: "LineTotal" },
        { text: "Date", value: "DocDate" },
        // { text: "Sold By", value: "soldby.name" },
      ],
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const url = "/canceled-order";
      // const self = this;
      this.loader = true;
      const data = this.cancelData;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const self = this;
      this.reportLoader = true;
      const url = "/bought-sold-products/14";
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportLoader = false;
            self.cancelData = res.ResponseData.AllProductsSold;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    this.getProducts();
  },
};
</script>

<style lang="scss" scoped>
</style>